import { useEffect, useRef } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    const returnTo = sessionStorage.getItem("gl_return") || "/inbox";
    if (!sessionId) {
      window.location.replace(returnTo);
      return;
    }
    axios
      .get(`${API}/auth/session`, { params: { session_id: sessionId }, withCredentials: true })
      .then(() => {
        sessionStorage.removeItem("gl_return");
        window.location.replace(returnTo);
      })
      .catch(() => window.location.replace(returnTo));
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink font-body text-white">
      <p className="flex items-center gap-3 text-sm font-semibold uppercase tracking-[0.2em] text-white/60">
        <Loader2 className="h-5 w-5 animate-spin text-accentlight" /> Signing you in…
      </p>
    </div>
  );
}
